import { request } from '@@/plugin-request';

export async function create(payload) {
  return request('/api/materials/create', { method: 'POST', data: payload });
}

export async function createLink(payload) {
  return request('/api/links/create', { method: 'POST', data: payload });
}

export async function query(payload) {
  return request('/api/materials/query', { method: 'GET', params: payload });
}

export async function update(payload) {
  return request('/api/materials/update', { method: 'PUT', data: payload });
}
